module.exports = __webpack_public_path__ + "media/images/flags/4x3/per-e7a9389abb40adc15f7906e849fe00ef.svg";